var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('table',{staticClass:"table table-hover",attrs:{"id":_vm.id}},[_vm._m(0),_vm._v(" "),_c('tbody')])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("Campos")]),_vm._v(" "),_c('th',[_vm._v("Formulas")]),_vm._v(" "),_c('th',[_vm._v("Redondeo")]),_vm._v(" "),_c('th',[_vm._v("Tipo de redondeo")]),_vm._v(" "),_c('th',[_vm._v(" ")])])])
}]

export { render, staticRenderFns }